export default function learningReportValidation(values: any) {
  const errors: any = {};
  if (!values.learningReportType) {
    errors.learningReportType = 'Report type required!';
  }
  return errors;
}
